import { render } from "./dispatched-sales.vue?vue&type=template&id=7b40a986"
import script from "./dispatched-sales.vue?vue&type=script&lang=js"
export * from "./dispatched-sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__